var map = {
	"./image1.png": 74032,
	"./image10.png": 87506,
	"./image2.png": 39435,
	"./image3.png": 75778,
	"./image4.png": 84925,
	"./image5.png": 47444,
	"./image6.png": 69903,
	"./image7.png": 1158,
	"./image8.png": 40961,
	"./image9.png": 68248
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 14824;